import React, { useState, useRef } from "react";
import "./AudioRecorderModal.css"; // Import CSS file
import { base_url } from "../secrets/env";
import failedIcon from '../assets/images/failed_icon.png'
import successIcon from '../assets/images/success_icon.png'
import { PulseLoader } from "react-spinners";
import { playMicCloseSound, playMicStartSound, preloadAudio } from "./audio";

const AudioRecorderModal = ({ onClose}) => {
  const [status, setStatus] = useState('compose');
  const [sending, setSending] = useState(false);
  let [loading, setLoading] = useState(false);
  const [recordingState, setRecordingState] = useState("idle"); // "idle", "recording", "recorded"
  const clickedOutsideOrCancelRef = useRef(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunks = useRef([]);
  const color ='#080E57'
  let audioContext = null
  let analyser
  let microphone
  let sampleData = [];
  let mediaRecorder = null;
  let recordingChunks = [];
  let controller;
  let threshold = 1.5;
  let thresholdSet = false;
  let belowThresholdStartTime = null;
  let dataArray;
  let micStartTime;
  let micTotalTimeTaken;
  const startRecording = async () => {
    try {
      preloadAudio()
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // const audio = new Audio('audios/start_rec.mp3');
      // audio.play();
      playMicStartSound()
      // const mediaRecorder = new MediaRecorder(stream);
      mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunks.current = [];

      audioContext = new (window.AudioContext || window.webkitAudioContext)();
      analyser = audioContext.createAnalyser();
      microphone = audioContext.createMediaStreamSource(stream);
      microphone.connect(analyser);
      analyser.fftSize = 256;
      dataArray = new Uint8Array(analyser.frequencyBinCount);
      mediaRecorder.start();

      mediaRecorder.ondataavailable = (event) => {
        audioChunks.current.push(event.data);
      };
      mediaRecorder.onstop = () => {
        stream.getTracks().forEach(track => track.stop());
        const audioBlob = new Blob(audioChunks.current, { type: "audio/mp3" });
        setAudioBlob(audioBlob);
        setRecordingState("recorded");
      };

      // mediaRecorder.start();
      setRecordingState("recording");
      logAmplitude()
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };

  const stopRecording = () => {
    // if (mediaRecorderRef.current) {
    //   mediaRecorderRef.current.stop();
    // }
    stopListening()
  };

  const sendAudio = async () => {
    if (!audioBlob) return;
    setSending(true)
    setStatus('sending')
    setLoading(true)
    const formData = new FormData();
    // formData.append("audio", audioBlob, "recorded_audio.wav");
    formData.append("jsonFile", audioBlob, "recorded_audio.mp3");

    try {
      const response = await fetch(`${base_url}/api/v1/send-audio-note`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setStatus('sent');
        const audio = new Audio('audios/success.wav');
        audio.play();
      } else {
        setStatus('failed');
        const audio = new Audio('audios/error.mp3');
        audio.play();
      }
    } catch (error) {
      setStatus('failed');
      setLoading(false)
      const audio = new Audio('audios/error.mp3');
      audio.play();
      console.error("Error sending audio:", error);
    }finally {
      setSending(false);
      setLoading(false)
    }
  };

  const reset = () => {
    setStatus('compose');
    setAudioBlob(null);
    setRecordingState('idle')
  };
  
  
  function logAmplitude() {
    if(audioContext.state === 'suspended') {
      audioContext.resume();
      // console.log("AudioContext resumed");
    }
    analyser.getByteTimeDomainData(dataArray);
  
    let sum = 0;
    for (let i = 0; i < dataArray.length; i++) {
      sum += (dataArray[i] - 128) ** 2;
    }
    const amplitude = Math.sqrt(sum / dataArray.length);
  
    // console.log("Amplitude:", amplitude);
  
    if (!thresholdSet) {
      if (sampleData.length < 5) {
        sampleData.push(amplitude);
      }
      if (sampleData.length === 5) {
        // console.log("Observed amplitudes:", sampleData);
        const sortedAmplitudes = sampleData.sort((a, b) => b - a);
        const a = sortedAmplitudes[0];
        const b = sortedAmplitudes[1];
        const c = sortedAmplitudes[2];
  
        const total=sortedAmplitudes.reduce((acc,val)=>acc+val,0);
             threshold=total/4;   
             threshold=0.75*threshold;     
        // if (threshold < 2) {
        //     threshold = 2;
        // }
        if (threshold <= 2) {
          threshold = 2;
        }
        // console.log("Threshold set to:", threshold);
        thresholdSet = true;
  
        belowThresholdStartTime = null;
      }
    } else {
      if(Date.now() - micStartTime >= 14800){
        // console.log("Mic stopped due to timeout");
        stopListening();
        return;
      }
      if (amplitude < threshold || amplitude>threshold+30) {
        if (belowThresholdStartTime === null) {
          belowThresholdStartTime = Date.now();
        } else if (Date.now() - belowThresholdStartTime >= 1600) {
          // console.log(
          //   "Amplitude below threshold for 1600ms. Stopping recording."
          // );
          stopListening();
          return;
        }
      } else {
        belowThresholdStartTime = null;
      }
    }
  
    setTimeout(logAmplitude, 400);
  }

  function stopListening() {
    
    if (mediaRecorder && mediaRecorder.state === "recording") {
      // const audio = new Audio('audios/stop_rec.mp3');
      if (!clickedOutsideOrCancelRef.current) {
        // audio.play();
        playMicCloseSound()
      }
      mediaRecorder.stop();
      mediaRecorder.stream.getTracks().forEach(track => track.stop());
      micTotalTimeTaken = Date.now() - micStartTime;
    } else {
      // console.warn("No recording in progress or no data available.");
    }
  }

  return (
    <div className="modal-overlay" onClick={()=>{
      clickedOutsideOrCancelRef.current = true;
      // onClose()
      if (!loading) {
        onClose();
      }
    }}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          { status === 'compose' ? (
              <>
                <h2 className="modal-title">Send an Audio Note</h2>
                <div className="mic-container">
                  <img
                    onClick={recordingState === "idle" ? startRecording : stopRecording}
                    className={`mic-button ${recordingState}`}
                    src={recordingState === "idle" ? "images/mic_icon.png" : recordingState === "recording" ? "images/mic_icon_recording.png" : 'images/mic_icon_recorded.png'}
                    alt="Mic"
                  >
                  </img>
                  {/* <button
                    onClick={recordingState === "idle" ? startRecording : stopRecording}
                    className={`mic-button ${recordingState}`}
                  >
                    🎤
                  </button> */}
                  <p className={`mic-status ${recordingState}`}>
                    {recordingState === "idle"
                      ? "Start"
                      : recordingState === "recording"
                      ? "Recording"
                      : "Recorded"}
                  </p>
                </div>
                <div className="modal-actions">
                  <button className="cancel-button" onClick={()=>{
                    clickedOutsideOrCancelRef.current = true;
                    onClose()
                  }}>
                    Cancel
                  </button>
                  <button
                    // className={`send-button ${audioBlob ? "active" : "disabled"}`}
                    className={`send-button ${(!audioBlob || sending) ? "disabled" : "active"}`}
                    disabled={!audioBlob || sending}
                    onClick={sendAudio}
                  >
                    Send
                  </button>
                </div>
              </>
          ) : loading ? (
            <>
              <h2 className="modal-title">Please wait, sending Audio Note</h2>
              <div className="sweet-loading">
                <PulseLoader
                  color={color}
                  loading={loading}
                  // cssOverride={override}
                  size={30}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
              <div className="modal-buttons">
                <button className={`cancel1 ${(!audioBlob || loading) ? "disabled" : "active"}`} >Cancel</button>
                <button
                // className="send"
                    className={`send-button ${(!audioBlob || loading) ? "disabled" : "active"}`}
                    disabled={!audioBlob || loading}
                >
                Send
                </button>
              </div>
            </>
          ) : status === 'sent' ? (
            <>
              <h2 className="modal-title">Audio Note Sent Successfully</h2>
              {/* <img  src="/images/success_icon.png" alt="Success" /> */}
              <div className="failed-success-container">
                <img  src={successIcon} alt="Success" />
              </div>
              <div className="modal-buttons2">
                <button className="cancel large-width" onClick={onClose}>Cancel</button>
                <button className="write-again" onClick={reset}>Record Again</button>
              </div>
            </>
          ) : (
            <>
              <h2 className="modal-title">Failed to Send Audio Note</h2>
              <div className="failed-success-container">
                <img src={failedIcon} alt="Failed" />
              </div>
              {/* <img src="/images/failed_icon.png" alt="Failed" /> */}
              <div className="modal-buttons2">
                <button className="cancel large-width" onClick={onClose}>Cancel</button>
                <button className="write-again" onClick={reset}>Record Again</button>
              </div>
            </>
          )}
        </div>
      
    </div>
  );
};

export default AudioRecorderModal;
